export default String.raw`
.comparison {
    &__bar {
        padding: 16px 32px;
    }
}
`